import type { Vehicle } from './vehicles'

/** Public source snapshots checked on 2026-09-26. See docs/vehicle-template.md. */
export const importedVehicles = [
  {
    "id": "665",
    "slug": "audi-2-0-tdi-mhev-s-line-edition-204cv-s-tronic",
    "make": "Audi",
    "model": "A5 Avant 2.0 TDI MHEV S line edition 204cv S tronic",
    "source": "audit-demo",
    "auditedAt": "2026-09-26",
    "sourceUrl": "https://ts-auto.it/scheda-veicolo/665/109/audi-2-0-tdi-mhev-s-line-edition-204cv-s-tronic",
    "publication": "published",
    "offerType": "sale",
    "facts": {
      "energy": "dieselMildHybrid",
      "transmission": "automatic",
      "year": 2025,
      "mileageKm": 20000,
      "price": {
        "amountEuro": 46000,
        "verifiedAt": "2026-09-26"
      }
    },
    "specifications": {
      "stockId": "26665",
      "condition": {
        "it": "Usato",
        "en": "Used"
      },
      "registration": {
        "it": "2025-03",
        "en": "2025-03"
      },
      "displacementCc": 1968,
      "powerKw": 150,
      "powerHp": 204,
      "gears": 7,
      "body": {
        "it": "Familiare",
        "en": "Estate"
      },
      "drive": {
        "it": "Anteriore",
        "en": "Front-wheel drive"
      },
      "doors": 5,
      "seats": 5,
      "emissionClass": "Euro 6",
      "widthCm": 186.0,
      "heightCm": 146.0,
      "lengthCm": 483.0,
      "bootLitres": 448.0,
      "weightKg": 1910.0,
      "powerRpm": 3800.0,
      "topSpeedKmh": 240.0,
      "co2GKm": 125.0,
      "combinedL100Km": 5.0,
      "accelerationSeconds": 7.7,
      "torqueNm": 400,
      "torqueRpm": 1750,
      "engineType": {
        "it": "TDI mHEV+",
        "en": "TDI mHEV+"
      },
      "vatDeductible": true,
      "transferIncluded": false
    },
    "accessories": [
      {
        "id": "665-0",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Climatizzatore deluxe a 3 zone",
          "en": "Deluxe three-zone climate control"
        }
      },
      {
        "id": "665-1",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Sedili anteriori riscaldati",
          "en": "Heated front seats"
        }
      },
      {
        "id": "665-2",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Volante multifunzionale in pelle con bilancieri",
          "en": "Multifunction leather steering wheel with shift paddles"
        }
      },
      {
        "id": "665-3",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Adaptive cruise control",
          "en": "Adaptive cruise control"
        }
      },
      {
        "id": "665-4",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Lane departure warning con emergency assist",
          "en": "Lane departure warning with emergency assist"
        }
      },
      {
        "id": "665-5",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Sistema di controllo pressione pneumatici",
          "en": "Tyre pressure monitoring"
        }
      },
      {
        "id": "665-6",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Attacchi i-Size e ISOFIX",
          "en": "i-Size and ISOFIX child seat mounts"
        }
      },
      {
        "id": "665-7",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Top view camera",
          "en": "Top view camera"
        }
      },
      {
        "id": "665-8",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Park assist plus",
          "en": "Park assist plus"
        }
      },
      {
        "id": "665-9",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Audi virtual cockpit plus",
          "en": "Audi virtual cockpit plus"
        }
      },
      {
        "id": "665-10",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Navigazione MMI plus con MMI touch",
          "en": "MMI navigation plus with MMI touch"
        }
      },
      {
        "id": "665-11",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Smartphone interface e Audi application store",
          "en": "Smartphone interface and Audi application store"
        }
      },
      {
        "id": "665-12",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Proiettori anteriori Matrix LED",
          "en": "Matrix LED headlights"
        }
      },
      {
        "id": "665-13",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Cerchi in lega da 19 pollici",
          "en": "19-inch alloy wheels"
        }
      },
      {
        "id": "665-14",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Portellone elettrico",
          "en": "Power tailgate"
        }
      },
      {
        "id": "665-15",
        "category": "other",
        "kind": "standard",
        "label": {
          "it": "Pacchetto Tech Plus",
          "en": "Tech Plus package"
        }
      },
      {
        "id": "665-16",
        "category": "other",
        "kind": "standard",
        "label": {
          "it": "Assetto sportivo",
          "en": "Sports suspension"
        }
      }
    ],
    "documents": [],
    "images": [
      {
        "src": "/media/vehicles/665_048.jpeg",
        "view": "frontThreeQuarter",
        "focalPoint": "50% 55%"
      },
      {
        "src": "/media/vehicles/665_047.jpeg",
        "view": "front",
        "focalPoint": "50% 50%"
      },
      {
        "src": "/media/vehicles/665_046.jpeg",
        "view": "rear",
        "focalPoint": "50% 50%"
      },
      {
        "src": "/media/vehicles/665_049.jpeg",
        "view": "rearThreeQuarter",
        "focalPoint": "50% 50%"
      },
      {
        "src": "/media/vehicles/665_043.jpeg",
        "view": "detail",
        "focalPoint": "50% 50%"
      }
    ],
    "description": {
      "it": "Audi A5 Avant 2.0 TDI MHEV S line edition 204cv S tronic. Familiare, 5 porte e 5 posti, 204 CV. Anteriore.",
      "en": "Audi A5 Avant 2.0 TDI MHEV S line edition 204cv S tronic. Estate, 5 doors and 5 seats, 204 PS. Front-wheel drive."
    }
  },
  {
    "id": "646",
    "slug": "hyundai-i30-wagon-1-0-t-gdi-prime-48v-120cv",
    "make": "Hyundai",
    "model": "i30 Wagon 1.0 T-GDI Prime 48V 120cv",
    "source": "audit-demo",
    "auditedAt": "2026-09-26",
    "sourceUrl": "https://ts-auto.it/scheda-veicolo/646/109/hyundai-i30-wagon-1-0-t-gdi-prime-48v-120cv",
    "publication": "published",
    "offerType": "sale",
    "facts": {
      "energy": "petrolMildHybrid",
      "transmission": "manual",
      "year": 2023,
      "mileageKm": 73000,
      "price": {
        "amountEuro": 13900,
        "verifiedAt": "2026-09-26"
      }
    },
    "specifications": {
      "stockId": "26646",
      "condition": {
        "it": "Usato",
        "en": "Used"
      },
      "registration": {
        "it": "2023-04",
        "en": "2023-04"
      },
      "displacementCc": 998,
      "powerKw": 88,
      "powerHp": 120,
      "gears": 6,
      "body": {
        "it": "Familiare",
        "en": "Estate"
      },
      "drive": {
        "it": "Anteriore",
        "en": "Front-wheel drive"
      },
      "doors": 5,
      "seats": 5,
      "emissionClass": "Euro 6",
      "widthCm": 180.0,
      "heightCm": 148.0,
      "lengthCm": 459.0,
      "bootLitres": 493.0,
      "weightKg": 1346.0,
      "powerRpm": 6000.0,
      "topSpeedKmh": 196.0,
      "co2GKm": 120.0,
      "urbanL100Km": 5.0,
      "extraUrbanL100Km": 4.0,
      "combinedL100Km": 5.0,
      "accelerationSeconds": 11.2,
      "torqueNm": 172,
      "torqueRpm": 1500,
      "engineType": {
        "it": "TGDi 48V",
        "en": "TGDi 48V"
      },
      "vatDeductible": true,
      "transferIncluded": false
    },
    "accessories": [
      {
        "id": "646-0",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Climatizzatore automatico bi-zona",
          "en": "Dual-zone automatic climate control"
        }
      },
      {
        "id": "646-1",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Supporto lombare elettrico del sedile guidatore",
          "en": "Electric driver lumbar support"
        }
      },
      {
        "id": "646-2",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Sedile posteriore abbattibile 60:40",
          "en": "60:40 split folding rear seat"
        }
      },
      {
        "id": "646-3",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Hyundai Smart Sense",
          "en": "Hyundai Smart Sense"
        }
      },
      {
        "id": "646-4",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Attacchi ISOFIX",
          "en": "ISOFIX child seat mounts"
        }
      },
      {
        "id": "646-5",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Cruise control",
          "en": "Cruise control"
        }
      },
      {
        "id": "646-6",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Controllo stabilità e pressione pneumatici",
          "en": "Stability control and tyre pressure monitoring"
        }
      },
      {
        "id": "646-7",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Touchscreen da 8 pollici con Apple CarPlay e Android Auto",
          "en": "8-inch touchscreen with Apple CarPlay and Android Auto"
        }
      },
      {
        "id": "646-8",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Retrocamera",
          "en": "Reversing camera"
        }
      },
      {
        "id": "646-9",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Caricatore wireless per smartphone",
          "en": "Wireless smartphone charging"
        }
      },
      {
        "id": "646-10",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Sensori di parcheggio anteriori e posteriori",
          "en": "Front and rear parking sensors"
        }
      },
      {
        "id": "646-11",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Fari anteriori Full LED",
          "en": "Full LED headlights"
        }
      },
      {
        "id": "646-12",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Cerchi in lega da 16 pollici",
          "en": "16-inch alloy wheels"
        }
      },
      {
        "id": "646-13",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Vetri posteriori oscurati",
          "en": "Rear privacy glass"
        }
      }
    ],
    "documents": [],
    "images": [
      {
        "src": "/media/vehicles/646_002.jpeg",
        "view": "frontThreeQuarter",
        "focalPoint": "50% 52%"
      }
    ],
    "description": {
      "it": "Hyundai i30 Wagon 1.0 T-GDI Prime 48V 120cv. Familiare, 5 porte e 5 posti, 120 CV. Anteriore.",
      "en": "Hyundai i30 Wagon 1.0 T-GDI Prime 48V 120cv. Estate, 5 doors and 5 seats, 120 PS. Front-wheel drive."
    }
  },
  {
    "id": "634",
    "slug": "bmw-m-550d-xdrive-auto",
    "make": "BMW",
    "model": "Serie 5 M Touring M 550d xDrive auto",
    "source": "audit-demo",
    "auditedAt": "2026-09-26",
    "sourceUrl": "https://ts-auto.it/scheda-veicolo/634/109/bmw-m-550d-xdrive-auto",
    "publication": "published",
    "offerType": "sale",
    "facts": {
      "energy": "diesel",
      "transmission": "automatic",
      "year": 2013,
      "mileageKm": 305000,
      "price": {
        "amountEuro": 11900,
        "verifiedAt": "2026-09-26"
      }
    },
    "specifications": {
      "stockId": "26634",
      "condition": {
        "it": "Usato",
        "en": "Used"
      },
      "registration": {
        "it": "2013-06",
        "en": "2013-06"
      },
      "displacementCc": 2993,
      "powerKw": 280,
      "powerHp": 381,
      "gears": 8,
      "body": {
        "it": "Familiare",
        "en": "Estate"
      },
      "drive": {
        "it": "Integrale",
        "en": "All-wheel drive"
      },
      "doors": 5,
      "seats": 5,
      "emissionClass": "Euro 6",
      "widthCm": 186.0,
      "heightCm": 146.0,
      "lengthCm": 490.0,
      "bootLitres": 520.0,
      "weightKg": 2065.0,
      "powerRpm": 4400.0,
      "topSpeedKmh": 250.0,
      "co2GKm": 190.0,
      "urbanL100Km": 7.0,
      "extraUrbanL100Km": 6.0,
      "combinedL100Km": 6.0,
      "accelerationSeconds": 4.9,
      "torqueNm": 740,
      "torqueRpm": 2000,
      "engineType": {
        "it": "d",
        "en": "d"
      },
      "transferIncluded": false
    },
    "accessories": [
      {
        "id": "634-0",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Climatizzatore automatico a 4 zone",
          "en": "Four-zone automatic climate control"
        }
      },
      {
        "id": "634-1",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Sedili anteriori sportivi",
          "en": "Front sports seats"
        }
      },
      {
        "id": "634-2",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Regolazione elettrica sedili anteriori con memoria guidatore",
          "en": "Electric front seats with driver memory"
        }
      },
      {
        "id": "634-3",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Schienale posteriore ripiegabile 40:20:40",
          "en": "40:20:40 folding rear backrest"
        }
      },
      {
        "id": "634-4",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Cruise control con funzione freno",
          "en": "Cruise control with braking function"
        }
      },
      {
        "id": "634-5",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Controllo dinamico di stabilità DSC",
          "en": "Dynamic stability control (DSC)"
        }
      },
      {
        "id": "634-6",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Predisposizione ISOFIX posteriore",
          "en": "Rear ISOFIX child seat mounts"
        }
      },
      {
        "id": "634-7",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Navigazione Professional",
          "en": "Professional navigation system"
        }
      },
      {
        "id": "634-8",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Park Distance Control anteriore e posteriore",
          "en": "Front and rear Park Distance Control"
        }
      },
      {
        "id": "634-9",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Interfaccia Bluetooth e USB",
          "en": "Bluetooth and USB interface"
        }
      },
      {
        "id": "634-10",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Fari allo Xeno e luci diurne LED",
          "en": "Xenon headlights and LED daytime running lights"
        }
      },
      {
        "id": "634-11",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Apertura Comfort portellone posteriore",
          "en": "Comfort tailgate opening"
        }
      },
      {
        "id": "634-12",
        "category": "other",
        "kind": "standard",
        "label": {
          "it": "Pacchetto sportivo M",
          "en": "M Sport package"
        }
      },
      {
        "id": "634-13",
        "category": "other",
        "kind": "standard",
        "label": {
          "it": "Pneumatici runflat",
          "en": "Run-flat tyres"
        }
      }
    ],
    "documents": [],
    "images": [],
    "description": {
      "it": "BMW Serie 5 M Touring M 550d xDrive auto. Familiare, 5 porte e 5 posti, 381 CV. Integrale.",
      "en": "BMW Serie 5 M Touring M 550d xDrive auto. Estate, 5 doors and 5 seats, 381 PS. All-wheel drive."
    }
  },
  {
    "id": "302",
    "slug": "lancia-1-0-firefly-hybrid-unyca-s-s-70cv",
    "make": "Lancia",
    "model": "Ypsilon 1.0 FireFly Hybrid UnYca 70cv",
    "source": "audit-demo",
    "auditedAt": "2026-09-26",
    "sourceUrl": "https://ts-auto.it/scheda-veicolo/302/109/lancia-1-0-firefly-hybrid-unyca-s-s-70cv",
    "publication": "published",
    "offerType": "rental",
    "facts": {
      "energy": "petrolMildHybrid",
      "transmission": "manual",
      "year": 2022
    },
    "specifications": {
      "stockId": "23302",
      "condition": {
        "it": "Usato",
        "en": "Used"
      },
      "registration": {
        "it": "2022-12",
        "en": "2022-12"
      },
      "displacementCc": 999,
      "powerKw": 51,
      "powerHp": 70,
      "gears": 6,
      "body": {
        "it": "Berlina",
        "en": "Hatchback"
      },
      "drive": {
        "it": "Anteriore",
        "en": "Front-wheel drive"
      },
      "doors": 5,
      "seats": 4,
      "emissionClass": "Euro 6",
      "widthCm": 168.0,
      "heightCm": 152.0,
      "lengthCm": 384.0,
      "bootLitres": 245.0,
      "weightKg": 1055.0,
      "powerRpm": 6000.0,
      "topSpeedKmh": 163.0,
      "co2GKm": 110.0,
      "combinedL100Km": 5.0,
      "accelerationSeconds": 14.2,
      "torqueNm": 92,
      "torqueRpm": 3500,
      "engineType": {
        "it": "FireFly Hybrid",
        "en": "FireFly Hybrid"
      },
      "vatDeductible": true
    },
    "accessories": [],
    "documents": [],
    "images": [
      {
        "src": "/media/vehicles/302_002.jpg",
        "view": "frontThreeQuarter",
        "focalPoint": "50% 50%"
      }
    ],
    "description": {
      "it": "Lancia Ypsilon 1.0 FireFly Hybrid UnYca 70cv. Berlina, 5 porte e 4 posti, 70 CV. Anteriore.",
      "en": "Lancia Ypsilon 1.0 FireFly Hybrid UnYca 70cv. Hatchback, 5 doors and 4 seats, 70 PS. Front-wheel drive."
    },
    "commercialNotes": {
      "it": "Veicolo per noleggio. Richiedi un preventivo in base alla durata e ai chilometri previsti. Immagine illustrativa del modello.",
      "en": "Rental vehicle. Request a quote based on duration and expected mileage. Illustrative model image."
    }
  },
  {
    "id": "321",
    "slug": "kia-1-6-crdi-mhev-style-dct",
    "make": "Kia",
    "model": "Sportage 1.6 CRDi MHEV Style DCT",
    "source": "audit-demo",
    "auditedAt": "2026-09-26",
    "sourceUrl": "https://ts-auto.it/scheda-veicolo/321/109/kia-1-6-crdi-mhev-style-dct",
    "publication": "published",
    "offerType": "sale",
    "facts": {
      "energy": "dieselMildHybrid",
      "transmission": "automatic",
      "year": 2024
    },
    "specifications": {
      "stockId": "24321",
      "condition": {
        "it": "Usato",
        "en": "Used"
      },
      "registration": {
        "it": "2024-02",
        "en": "2024-02"
      },
      "displacementCc": 1598,
      "powerKw": 100,
      "powerHp": 136,
      "gears": 7,
      "body": {
        "it": "SUV",
        "en": "SUV"
      },
      "drive": {
        "it": "Anteriore",
        "en": "Front-wheel drive"
      },
      "doors": 5,
      "seats": 5,
      "emissionClass": "Euro 6",
      "widthCm": 187.0,
      "heightCm": 165.0,
      "lengthCm": 452.0,
      "bootLitres": 526.0,
      "weightKg": 1602.0,
      "powerRpm": 4000.0,
      "topSpeedKmh": 180.0,
      "co2GKm": 130.0,
      "combinedL100Km": 5.0,
      "accelerationSeconds": 11.4,
      "torqueNm": 180,
      "engineType": {
        "it": "CRDi MHEV",
        "en": "CRDi MHEV"
      },
      "vatDeductible": true
    },
    "accessories": [],
    "documents": [],
    "images": [
      {
        "src": "/media/vehicles/321_011.jpg",
        "view": "frontThreeQuarter",
        "focalPoint": "50% 50%"
      },
      {
        "src": "/media/vehicles/321_002.jpg",
        "view": "detail",
        "focalPoint": "50% 50%"
      },
      {
        "src": "/media/vehicles/321_012.jpg",
        "view": "detail",
        "focalPoint": "50% 50%"
      },
      {
        "src": "/media/vehicles/321_013.jpg",
        "view": "detail",
        "focalPoint": "50% 50%"
      }
    ],
    "description": {
      "it": "Kia Sportage 1.6 CRDi MHEV Style DCT. SUV, 5 porte e 5 posti, 136 CV. Anteriore.",
      "en": "Kia Sportage 1.6 CRDi MHEV Style DCT. SUV, 5 doors and 5 seats, 136 PS. Front-wheel drive."
    },
    "commercialNotes": {
      "it": "Trattativa in sede. Contattaci per prezzo e condizioni.",
      "en": "Price on request. Contact us for pricing and terms."
    }
  },
  {
    "id": "467",
    "slug": "jeep-1-2-t-summit-fwd-100cv",
    "make": "Jeep",
    "model": "Avenger 1.2 T. Summit FWD 100cv",
    "source": "audit-demo",
    "auditedAt": "2026-09-26",
    "sourceUrl": "https://ts-auto.it/scheda-veicolo/467/109/jeep-1-2-t-summit-fwd-100cv",
    "publication": "published",
    "offerType": "sale",
    "facts": {
      "energy": "petrol",
      "transmission": "manual",
      "mileageKm": 1,
      "price": {
        "amountEuro": 25000,
        "verifiedAt": "2026-09-26"
      }
    },
    "specifications": {
      "stockId": "25467",
      "condition": {
        "it": "Nuovo",
        "en": "New"
      },
      "registration": {
        "it": "Da immatricolare",
        "en": "Not yet registered"
      },
      "displacementCc": 1199,
      "powerKw": 74,
      "powerHp": 100,
      "gears": 6,
      "body": {
        "it": "SUV",
        "en": "SUV"
      },
      "drive": {
        "it": "Anteriore",
        "en": "Front-wheel drive"
      },
      "doors": 5,
      "seats": 5,
      "emissionClass": "Euro 6",
      "widthCm": 178.0,
      "heightCm": 153.0,
      "lengthCm": 408.0,
      "bootLitres": 380.0,
      "weightKg": 1255.0,
      "powerRpm": 5500.0,
      "topSpeedKmh": 184.0,
      "co2GKm": 129.0,
      "combinedL100Km": 6.0,
      "accelerationSeconds": 10.6,
      "torqueNm": 205,
      "engineType": {
        "it": "Turbo",
        "en": "Turbo"
      },
      "vatDeductible": true,
      "transferIncluded": false
    },
    "accessories": [
      {
        "id": "467-0",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Climatizzatore automatico",
          "en": "Automatic climate control"
        }
      },
      {
        "id": "467-1",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Sedili anteriori riscaldabili",
          "en": "Heated front seats"
        }
      },
      {
        "id": "467-2",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Illuminazione ambiente a 8 colori",
          "en": "Eight-colour ambient lighting"
        }
      },
      {
        "id": "467-3",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Adaptive Cruise Control",
          "en": "Adaptive Cruise Control"
        }
      },
      {
        "id": "467-4",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Blind Spot Monitoring",
          "en": "Blind Spot Monitoring"
        }
      },
      {
        "id": "467-5",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Frenata di emergenza con riconoscimento pedoni e ciclisti",
          "en": "Emergency braking with pedestrian and cyclist detection"
        }
      },
      {
        "id": "467-6",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Camera posteriore a 180°",
          "en": "180° rear camera"
        }
      },
      {
        "id": "467-7",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Sensori di parcheggio a 360°",
          "en": "360° parking sensors"
        }
      },
      {
        "id": "467-8",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Uconnect touchscreen da 10,25 pollici",
          "en": "10.25-inch Uconnect touchscreen"
        }
      },
      {
        "id": "467-9",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Apple CarPlay e Android Auto wireless",
          "en": "Wireless Apple CarPlay and Android Auto"
        }
      },
      {
        "id": "467-10",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Caricatore wireless per smartphone",
          "en": "Wireless smartphone charging"
        }
      },
      {
        "id": "467-11",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Fari Full LED anteriori e posteriori",
          "en": "Full LED headlights and tail lights"
        }
      },
      {
        "id": "467-12",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Cerchi in lega da 18 pollici",
          "en": "18-inch alloy wheels"
        }
      },
      {
        "id": "467-13",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Portellone elettrico hands-free",
          "en": "Hands-free power tailgate"
        }
      },
      {
        "id": "467-14",
        "category": "other",
        "kind": "standard",
        "label": {
          "it": "Selec-Terrain con 6 modalità di guida",
          "en": "Selec-Terrain with six driving modes"
        }
      }
    ],
    "documents": [],
    "images": [
      {
        "src": "/media/vehicles/467_002.jpg",
        "view": "frontThreeQuarter",
        "focalPoint": "50% 50%"
      },
      {
        "src": "/media/vehicles/467_009.jpg",
        "view": "detail",
        "focalPoint": "50% 50%"
      },
      {
        "src": "/media/vehicles/467_018.jpg",
        "view": "detail",
        "focalPoint": "50% 50%"
      },
      {
        "src": "/media/vehicles/467_021.jpg",
        "view": "detail",
        "focalPoint": "50% 50%"
      }
    ],
    "description": {
      "it": "Jeep Avenger 1.2 T. Summit FWD 100cv. SUV, 5 porte e 5 posti, 100 CV. Anteriore.",
      "en": "Jeep Avenger 1.2 T. Summit FWD 100cv. SUV, 5 doors and 5 seats, 100 PS. Front-wheel drive."
    }
  },
  {
    "id": "669",
    "slug": "nissan-1-3-mhev-n-connecta-2wd-158cv-xtronic",
    "make": "Nissan",
    "model": "Qashqai 1.3 MHEV N-Connecta 158cv Xtronic",
    "source": "audit-demo",
    "auditedAt": "2026-09-26",
    "sourceUrl": "https://ts-auto.it/scheda-veicolo/669/109/nissan-1-3-mhev-n-connecta-2wd-158cv-xtronic",
    "publication": "published",
    "offerType": "sale",
    "facts": {
      "energy": "petrolMildHybrid",
      "transmission": "automatic",
      "year": 2026,
      "price": {
        "amountEuro": 28000,
        "verifiedAt": "2026-09-26"
      }
    },
    "specifications": {
      "stockId": "26669",
      "condition": {
        "it": "Nuovo",
        "en": "New"
      },
      "registration": {
        "it": "2026-05",
        "en": "2026-05"
      },
      "displacementCc": 1332,
      "powerKw": 116,
      "powerHp": 158,
      "body": {
        "it": "CrossOver",
        "en": "Crossover"
      },
      "drive": {
        "it": "Anteriore",
        "en": "Front-wheel drive"
      },
      "doors": 5,
      "seats": 5,
      "emissionClass": "Euro 6",
      "widthCm": 184.0,
      "heightCm": 163.0,
      "lengthCm": 443.0,
      "bootLitres": 455.0,
      "weightKg": 1540.0,
      "powerRpm": 5500.0,
      "topSpeedKmh": 199.0,
      "co2GKm": 141.0,
      "combinedL100Km": 6.0,
      "accelerationSeconds": 9.2,
      "torqueNm": 270,
      "torqueRpm": 1800,
      "engineType": {
        "it": "Mild Hybrid",
        "en": "Mild Hybrid"
      },
      "vatDeductible": true,
      "transferIncluded": false
    },
    "accessories": [
      {
        "id": "669-0",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Climatizzatore automatico dual-zone",
          "en": "Dual-zone automatic climate control"
        }
      },
      {
        "id": "669-1",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Supporto lombare elettrico lato guida",
          "en": "Electric driver lumbar support"
        }
      },
      {
        "id": "669-2",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Sedili in tessuto e pelle sintetica",
          "en": "Cloth and synthetic leather seats"
        }
      },
      {
        "id": "669-3",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "ProPILOT con Navi-Link",
          "en": "ProPILOT with Navi-Link"
        }
      },
      {
        "id": "669-4",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Blind Spot Warning e Intervention",
          "en": "Blind Spot Warning and Intervention"
        }
      },
      {
        "id": "669-5",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Intelligent Cruise Control",
          "en": "Intelligent Cruise Control"
        }
      },
      {
        "id": "669-6",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Frenata automatica posteriore",
          "en": "Rear automatic braking"
        }
      },
      {
        "id": "669-7",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "AVM 3D con riconoscimento oggetti in movimento",
          "en": "3D Around View Monitor with moving object detection"
        }
      },
      {
        "id": "669-8",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Navigatore da 12,3 pollici con Google Automotive Services",
          "en": "12.3-inch navigation with Google Automotive Services"
        }
      },
      {
        "id": "669-9",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Apple CarPlay e Android Auto",
          "en": "Apple CarPlay and Android Auto"
        }
      },
      {
        "id": "669-10",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Caricatore wireless",
          "en": "Wireless charging"
        }
      },
      {
        "id": "669-11",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Cerchi in lega da 18 pollici",
          "en": "18-inch alloy wheels"
        }
      },
      {
        "id": "669-12",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Fari anteriori LED",
          "en": "LED headlights"
        }
      },
      {
        "id": "669-13",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Retrovisori elettrici, riscaldabili e ripiegabili",
          "en": "Electric, heated and folding door mirrors"
        }
      }
    ],
    "documents": [],
    "images": [
      {
        "src": "/media/vehicles/669_025.jpeg",
        "view": "frontThreeQuarter",
        "focalPoint": "50% 50%"
      }
    ],
    "description": {
      "it": "Nissan Qashqai 1.3 MHEV N-Connecta 158cv Xtronic. CrossOver, 5 porte e 5 posti, 158 CV. Anteriore.",
      "en": "Nissan Qashqai 1.3 MHEV N-Connecta 158cv Xtronic. Crossover, 5 doors and 5 seats, 158 PS. Front-wheel drive."
    }
  },
  {
    "id": "691",
    "slug": "opel-1-2-elegance-s-s-130cv-at6",
    "make": "Opel",
    "model": "Crossland 1.2 Elegance 130cv AT6",
    "source": "audit-demo",
    "auditedAt": "2026-09-26",
    "sourceUrl": "https://ts-auto.it/scheda-veicolo/691/109/opel-1-2-elegance-s-s-130cv-at6",
    "publication": "published",
    "offerType": "sale",
    "facts": {
      "energy": "petrol",
      "transmission": "automatic",
      "year": 2023,
      "mileageKm": 105000,
      "price": {
        "amountEuro": 11000,
        "verifiedAt": "2026-09-26"
      }
    },
    "specifications": {
      "stockId": "26691",
      "condition": {
        "it": "Usato",
        "en": "Used"
      },
      "registration": {
        "it": "2023-06",
        "en": "2023-06"
      },
      "displacementCc": 1199,
      "powerKw": 96,
      "powerHp": 130,
      "gears": 6,
      "body": {
        "it": "CrossOver",
        "en": "Crossover"
      },
      "drive": {
        "it": "Anteriore",
        "en": "Front-wheel drive"
      },
      "doors": 5,
      "seats": 5,
      "emissionClass": "Euro 6",
      "widthCm": 177.0,
      "heightCm": 161.0,
      "lengthCm": 421.0,
      "bootLitres": 410.0,
      "weightKg": 1835.0,
      "powerRpm": 5550.0,
      "topSpeedKmh": 198.0,
      "co2GKm": 141.0,
      "combinedL100Km": 6.0,
      "accelerationSeconds": 10.2,
      "torqueNm": 198,
      "vatDeductible": true,
      "transferIncluded": false,
      "owners": 1,
      "delivery": {
        "it": "In arrivo",
        "en": "Arriving soon"
      }
    },
    "accessories": [
      {
        "id": "691-0",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Climatizzatore automatico bi-zona",
          "en": "Dual-zone automatic climate control"
        }
      },
      {
        "id": "691-1",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Volante in pelle regolabile",
          "en": "Adjustable leather steering wheel"
        }
      },
      {
        "id": "691-2",
        "category": "comfort",
        "kind": "standard",
        "label": {
          "it": "Luci ambiente LED",
          "en": "LED ambient lighting"
        }
      },
      {
        "id": "691-3",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Safety Pack (Opel Eye)",
          "en": "Safety Pack (Opel Eye)"
        }
      },
      {
        "id": "691-4",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Avviso di superamento involontario della carreggiata",
          "en": "Lane departure warning"
        }
      },
      {
        "id": "691-5",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Assistenza alla partenza in salita",
          "en": "Hill start assist"
        }
      },
      {
        "id": "691-6",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Cruise control con limitatore di velocità",
          "en": "Cruise control with speed limiter"
        }
      },
      {
        "id": "691-7",
        "category": "safety",
        "kind": "standard",
        "label": {
          "it": "Sistema di monitoraggio pressione pneumatici",
          "en": "Tyre pressure monitoring"
        }
      },
      {
        "id": "691-8",
        "category": "technology",
        "kind": "standard",
        "label": {
          "it": "Radio R4.0 IntelliLink",
          "en": "R4.0 IntelliLink radio"
        }
      },
      {
        "id": "691-9",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Fari eco-LED anteriori",
          "en": "Eco-LED headlights"
        }
      },
      {
        "id": "691-10",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Cerchi in lega da 16 pollici bicolore",
          "en": "16-inch two-tone alloy wheels"
        }
      },
      {
        "id": "691-11",
        "category": "exterior",
        "kind": "standard",
        "label": {
          "it": "Vetri posteriori oscurati",
          "en": "Rear privacy glass"
        }
      },
      {
        "id": "691-12",
        "category": "other",
        "kind": "standard",
        "label": {
          "it": "Sight & Light Pack",
          "en": "Sight & Light Pack"
        }
      }
    ],
    "documents": [],
    "images": [
      {
        "src": "/media/vehicles/691_017.jpeg",
        "view": "detail",
        "focalPoint": "50% 50%"
      }
    ],
    "description": {
      "it": "Opel Crossland 1.2 Elegance 130cv AT6. CrossOver, 5 porte e 5 posti, 130 CV. Anteriore.",
      "en": "Opel Crossland 1.2 Elegance 130cv AT6. Crossover, 5 doors and 5 seats, 130 PS. Front-wheel drive."
    }
  }
] satisfies readonly Vehicle[]
